module.exports = __webpack_public_path__ + "static/media/fr_export_share_active.7da5e70f.svg";